import React from 'react';

export default React.forwardRef(({className, ...props}, ref) => (
    <div className={`custom-toggle ${className}`} ref={ref} {...props}></div>
));